// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageEditFormActions-modulebutton__Cmhex";
var _2 = "ChatroomMessageEditFormActions-modulechatroomMessageEditFormActions__j68R1 ChatroomInputFormFields-moduleactions__La3I4";
export { _1 as "button", _2 as "chatroomMessageEditFormActions" }
